import type { RecentSearch } from "@/features/search/types";

const VALID_LOCATION_MODES = new Set(["place", "viewport", "coords"]);

function recentToSearchParams(s: RecentSearch): Record<string, string | number> {
  const params: Record<string, string | number> = { page: 1 };
  if (s.q) params.q = s.q;
  if (s.category) params.category = s.category;
  if (s.categoryName) params.category_name = s.categoryName;
  if (s.location) params.location = s.location;
  if (s.lat != null) params.lat = Number(s.lat);
  if (s.lng != null) params.lng = Number(s.lng);
  if (s.bounds) params.bounds = s.bounds;
  if (s.location_mode && VALID_LOCATION_MODES.has(s.location_mode)) {
    params.location_mode = s.location_mode;
  }
  if (s.when_date) params.when_date = s.when_date;
  if (s.when_time && s.when_time !== "any") {
    params.when_time = s.when_time;
  }
  return params;
}

export { recentToSearchParams };
